import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=71606d45&scoped=true&"
import script from "./Comments.vue?vue&type=script&lang=js&"
export * from "./Comments.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/comments.scss?vue&type=style&index=0&id=71606d45&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71606d45",
  null
  
)

export default component.exports